import { render } from "./USBankProtectSuspiciousEmail.vue?vue&type=template&id=541a9726&scoped=true"
import script from "./USBankProtectSuspiciousEmail.vue?vue&type=script&lang=js"
export * from "./USBankProtectSuspiciousEmail.vue?vue&type=script&lang=js"

import "./USBankProtectSuspiciousEmail.vue?vue&type=style&index=0&id=541a9726&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541a9726"]])

export default __exports__